import React, { useState, useEffect, useRef } from "react";
import "./SideNav.css";
import { Image, Accordion, Overlay, Popover } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Navigation } from "CommonComponent";
import { logout } from "actions"; // add logout action

const SideNav = () => {
  const location = useLocation();
  const [activeKey, setActiveKey] = useState([]);
  const [openMenuId, setOpenMenuId] = useState(null);
  const session = useSelector((state) => state.session);
  const dispatch = useDispatch();

  // Function to determine the active keys based on the current URL
  const getActiveKeysForUrl = (url, menuData) => {
    const activeKeys = [];

    const findParents = (url, items, parentKeys = []) => {
      for (const item of items) {
        if (
          item.href === url ||
          (item.children &&
            findParents(url, item.children, [...parentKeys, item.id]))
        ) {
          activeKeys.push(...parentKeys, item.id);
          return true;
        }
      }
      return false;
    };

    if (menuData) {
      findParents(url, menuData);
    }

    return activeKeys;
  };

  useEffect(() => {
    if (session.nested_menus) {
      const activeKeys = getActiveKeysForUrl(
        location.pathname.replace(/^\//, ""),
        session.nested_menus
      );
      setActiveKey(activeKeys);
    }
  }, [location.pathname, session.nested_menus]);

  // Handler for multi-open
  const handleSelect = (key) => {
    setActiveKey((prev) => {
      if (prev.includes(key)) {
        return prev.filter((k) => k !== key);
      } else {
        return [...prev, key];
      }
    });
  };

  // --- new: user tooltip state / refs ---
  const [showUserTooltip, setShowUserTooltip] = useState(false);
  const userBtnRef = useRef(null);
  const tooltipRef = useRef(null);

  const handleLogout = async (e) => {
    e.preventDefault();
    setShowUserTooltip(false);
    await dispatch(logout());
  };

  // close tooltip when clicking outside or pressing Escape
  useEffect(() => {
    const handleDocClick = (e) => {
      if (
        showUserTooltip &&
        tooltipRef.current &&
        !tooltipRef.current.contains(e.target) &&
        userBtnRef.current &&
        !userBtnRef.current.contains(e.target)
      ) {
        setShowUserTooltip(false);
      }
    };

    const handleKey = (e) => {
      if (e.key === "Escape" && showUserTooltip) setShowUserTooltip(false);
    };

    document.addEventListener("mousedown", handleDocClick);
    document.addEventListener("keydown", handleKey);
    return () => {
      document.removeEventListener("mousedown", handleDocClick);
      document.removeEventListener("keydown", handleKey);
    };
  }, [showUserTooltip]);

  return (
    <div className="sideNav-wrapper">
      <div className="sideNav">
        {/* Header: Logo (always expanded) */}
        <div className="d-flex justify-content-center mb-3">
          <Image
            src="/assets/images/Bnx-logo.svg"
            alt="Logo"
            className="sidebar-logo"
          />
        </div>

        <div className="accordian-parent">
          <Accordion
            activeKey={activeKey}
            onSelect={handleSelect}
            className="custom-accordion"
            alwaysOpen
          >
            {session.nested_menus && (
              <Navigation
                component="div"
                pages={session.nested_menus}
                isMenuCollapse={true} // always expanded
                setActiveKey={setActiveKey}
                activeKey={activeKey}
                onSelect={handleSelect}
                openMenuId={openMenuId}
                setOpenMenuId={setOpenMenuId}
              />
            )}
          </Accordion>
        </div>
        <div className="bottom-button-container">
          <button className="setting-btn">
            {" "}
            <img src="/assets/images/setting-icon.svg" alt="" />{" "}
          </button>

          {/* user button with click tooltip/popover showing logout */}
          <div className="tooltip-wrapper" ref={tooltipRef}>
            <button
              ref={userBtnRef}
              className="user-button"
              onClick={() => setShowUserTooltip((s) => !s)}
              aria-haspopup="true"
              aria-expanded={showUserTooltip}
            >
              <img src="/assets/images/user.svg" alt="" />
            </button>

            <div
              className={`submenu-dropdown submenu-right ${
                showUserTooltip ? "show" : ""
              }`}
              style={{ display: showUserTooltip ? "block" : "none" }}
              role="menu"
              aria-hidden={!showUserTooltip}
            >
              <button
                className="btn btn-link d-flex align-items-center"
                onClick={handleLogout}
                style={{ textDecoration: "none", color: "#333" }}
              >
                <img
                  src="/assets/images/logout-icon.svg"
                  className="me-2"
                  alt="logout"
                />
                Logout
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SideNav;
